function Content({content}){
  return(
    <div>
      <b>{content}</b>
    </div>
  );
}

export default Content;
